"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;
exports.renderCart = renderCart;

var _themeCart = require("@shopify/theme-cart");

var cart = _interopRequireWildcard(_themeCart);

var _themeCurrency = require("@shopify/theme-currency");

var _themeImages = require("@shopify/theme-images");

var images = _interopRequireWildcard(_themeImages);

var _miniCart = require("./mini-cart.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var selectors = {
  cart: "[data-cart]",
  quantity: "[data-quantity-input]",
  subTotal: "[data-subtotal]",
  plus: "[data-quantity-plus]",
  minus: "[data-quantity-minus]",
  remove: "[data-remove-item]",
  item: "[data-cart-item]",
  items: "[data-cart-items]",
  emptyText: "Your cart is currently empty."
};

function init() {
  minusListener();
  plusListener();
  removeItemListener();
}

function minusListener() {
  document.querySelectorAll(selectors.minus).forEach(function (trigger) {
    trigger.addEventListener("click", function () {
      var quantity = this.nextElementSibling;
      var updateQuantity = parseInt(quantity.value) - 1;
      var key = quantity.getAttribute("data-key");
      if (updateQuantity > 0) {
        cart.updateItem(key, { quantity: updateQuantity }).then(function (state) {
          quantity.value = updateQuantity;
          renderSubtotal(state);
          (0, _miniCart.renderMiniCart)(state, true);
        });
      }
    });
  });
}

function plusListener() {
  document.querySelectorAll(selectors.plus).forEach(function (trigger) {
    trigger.addEventListener("click", function () {
      var quantity = this.previousElementSibling;
      var updateQuantity = parseInt(quantity.value) + 1;
      var key = quantity.getAttribute("data-key");
      cart.updateItem(key, { quantity: updateQuantity }).then(function (state) {
        var item = state.items.find(function (item) {
          return item.key === key;
        });
        if (item.quantity == updateQuantity) {
          quantity.value = updateQuantity;
          renderSubtotal(state);
          (0, _miniCart.renderMiniCart)(state, true);
        }
      });
    });
  });
}

function removeItemListener() {
  document.querySelectorAll(selectors.remove).forEach(function (trigger) {
    trigger.addEventListener("click", function () {
      var key = this.getAttribute("data-key");
      (0, _miniCart.removeItem)(key).then(function (state) {
        renderCart(state);
      });
    });
  });
}

function renderSubtotal(state) {
  document.querySelector(selectors.subTotal).textContent = (0, _themeCurrency.formatMoney)(state.items_subtotal_price);
}

function renderItems(state) {
  var selector = document.querySelector(selectors.items);
  selector.innerHTML = "";
  var container = document.createElement("div");
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = state.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;

      var img = "";
      if (item.image) {
        img = "<a href='" + item.url + "'><img src='" + images.getSizedImageUrl(item.image, "150x150") + "' /></a>";
      }
      var properties = "";
      for (var property in item.properties) {
        if (property.charAt(0) != "_") {
          var line = "<p>" + property + ": " + item.properties[property] + "</p>";
          properties = properties + line;
        }
      }
      var price = "";
      if (item.discounted_price != item.price) {
        price = "<div class=\"text-15 pt-1\">\n      <span class=\"visually-hidden\">" + window.theme.cart.originalPrice + "</span>\n      <s class=\"mr-2 text-battleshipGrey\">" + (0, _themeCurrency.formatMoney)(item.discounted_price) + "</s>\n      <span class=\"visually-hidden\">" + window.theme.cart.discounted_price + "</span>\n      <span>" + (0, _themeCurrency.formatMoney)(item.price) + "</span>\n  </div>";
      } else {
        price = "<div class=\"text-15 pt-1\"><span>" + (0, _themeCurrency.formatMoney)(item.price) + "</span></div>";
      }
      var variantTitle = "";
      if (item.variant_title !== item.product_title) {
        if (item.variant_title != null) {
          variantTitle = item.variant_title;
        }
      }

      var template = "\n    <div data-cart-item>\n    <div class=\"flex w-full\">\n        <div>\n            " + img + "\n        </div>\n        <div class=\"sm:flex justify-between w-full\">\n            <div class=\"ml-8\">\n                <a class=\"font-header text-17 font-semibold\" href=\"" + item.url + "\">" + item.product_title + "</a>\n                <p class=\"text-battleshipGrey text-12\">" + variantTitle + "</p>\n                <div class=\"text-battleshipGrey text-12\">\n                    " + properties + "\n                </div>\n                " + price + "\n            </div>\n            <div class=\"ml-8\">\n                <div class=\"cart-quantity\">\n                    <label class=\"visually-hidden\">" + window.theme.cart.quantity + "</label>\n                    <input class=\"cursor-pointer text-20 mr-4 text-brownGrey bg-transparent\" min=\"1\" data-quantity-minus type=\"button\" value=\"&ndash;\">\n                    <input class=\"w-6 input-number bg-transparent\" data-quantity-input name=\"updates[]\" id=\"updates_" + item.key + "\" data-key=\"" + item.key + "\" type=\"number\" readonly value=\"" + item.quantity + "\" min=\"1\" aria-label=\"" + window.theme.cart.item_quantity + "\">\n                    <input class=\"cursor-pointer text-20 text-brownGrey bg-transparent\" data-quantity-plus type=\"button\" value=\"+\">\n                </div>\n                <p class=\"text-battleshipGrey text-12 underline md:text-right text-left mt-2\">\n                    <a class=\"cursor-pointer\" data-remove-item data-key=\"" + item.key + "\">" + window.theme.cart.remove + "</a>\n                </p>\n            </div>\n        </div>\n    </div>\n    <div class=\"divider my-6\"></div>\n</div>\n          ";
      container.innerHTML += template;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  selector.appendChild(container);
}

function renderCart(state) {
  if (state.items.length > 0) {
    renderItems(state);
    renderSubtotal(state);
  } else {
    document.querySelector(selectors.cart).innerHTML = selectors.emptyText;
  }
  removeItemListener();
  minusListener();
  plusListener();
  (0, _miniCart.renderMiniCart)(state, true);
}